module.exports = __webpack_public_path__ + "img/blending-into-right-weapon.e1b23adb.png";